import { render, staticRenderFns } from "./UiItem.vue?vue&type=template&id=66c9b5f8"
import script from "./UiItem.vue?vue&type=script&lang=js"
export * from "./UiItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports